import { useMemo, useState } from "react";
import { CancelShipmentModal } from "../../components/OptionsForView/CancelShipmentModal";
import { CloseConsignmentModal } from "./CloseConsignmentModal";
import { LOCKED_SHIPMENT_STATUSES } from "./createReceiptFromShipmentHelpers";
import { componentWithCondition } from "../../components/hoc/componentWithConditionCheck";
import { CreateReceiptReviewDrawer } from "./CreateReceiptReviewDrawer";
import { createReceiptListSelectionState } from "./createReceiptFromShipmentHelpers";
import { ListActionBurgerMenu } from "../../components/OptionsForView/ListActionBurgerMenu";

const ShipmentOrderAction = ({
  selectedOrderFromListview,
  setSelectedOrder,
  getConsignmentByRule,
}) => {
  const [isOpenCancelShipment, setIsOpenCancelShipment] = useState(false);
  const [isCloseShipmentOpen, setIsCloseShipmentOpen] = useState(false);
  const [isCreateReceiptOpen, setIsCreateReceiptOpen] = useState(false);

  const createReceiptContext = useMemo(
    () => createReceiptListSelectionState(selectedOrderFromListview),
    [selectedOrderFromListview],
  );

  const isEnablededCancelShipment = useMemo(() => {
    const stateOfCancelShipment = selectedOrderFromListview.some(item =>
      ["Full Receipt Created", "Partial Receipt Created", "Cancelled", "Closed", "Completed"].includes(
        item.status,
      ),
    );

    return selectedOrderFromListview.length > 0 && !stateOfCancelShipment;
  }, [selectedOrderFromListview]);

  const canCloseShipments = useMemo(() => {
    if (!selectedOrderFromListview.length) return false;
    return !selectedOrderFromListview.some(item =>
      LOCKED_SHIPMENT_STATUSES.includes(item.status),
    );
  }, [selectedOrderFromListview]);

  const closeCancelShipment = () => {
    setIsOpenCancelShipment(false);
  };

  const burgerItems = useMemo(
    () => [
      {
        key: "close-shipment",
        label: "Close Shipment",
        onClick: () => setIsCloseShipmentOpen(true),
        disabled: !canCloseShipments,
        title: canCloseShipments ? "" : "Select shipments eligible to close.",
      },
      {
        key: "cancel-shipment",
        label: "Cancel Shipment",
        onClick: () => setIsOpenCancelShipment(true),
        disabled: !isEnablededCancelShipment,
        title: isEnablededCancelShipment ? "" : "Select shipments eligible to cancel.",
        isDanger: true,
      },
    ],
    [canCloseShipments, isEnablededCancelShipment],
  );

  return (
    <>
      {isOpenCancelShipment && (
        <CancelShipmentModal
          ordersName={selectedOrderFromListview}
          closeModal={closeCancelShipment}
          setSelectedOrder={setSelectedOrder}
        />
      )}
      {isCloseShipmentOpen && (
        <CloseConsignmentModal
          orders={selectedOrderFromListview}
          closeModal={() => setIsCloseShipmentOpen(false)}
          setSelectedOrder={setSelectedOrder}
        />
      )}
      {isCreateReceiptOpen && createReceiptContext.ok && (
        <CreateReceiptReviewDrawer
          isOpen={isCreateReceiptOpen}
          onClose={() => setIsCreateReceiptOpen(false)}
          source="list"
          shipments={selectedOrderFromListview}
          setSelectedOrder={setSelectedOrder}
          onSuccess={() => getConsignmentByRule?.()}
        />
      )}
      <li
        className={
          createReceiptContext.ok ? `tableButton activeState` : `tableButton disableState`
        }
      >
        <button
          type="button"
          disabled={!createReceiptContext.ok}
          title={createReceiptContext.ok ? "" : createReceiptContext.reason}
          onClick={() => setIsCreateReceiptOpen(true)}
        >
          Create Receipt
        </button>
      </li>
      <ListActionBurgerMenu items={burgerItems} />
    </>
  );
};

export const ShipmentOrderActionWithCheck = componentWithCondition(ShipmentOrderAction);
